import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import BeginnersGuide from "../pages/articles/BeginnersGuide";
import KakobuyReview from "../pages/articles/KakobuyReview";
import SuperbuyComparison from "../pages/articles/SuperbuyComparison";
import BestSystems from "../pages/articles/BestSystems";
import SafetyGuide from "../pages/articles/SafetyGuide";
import ShoppingTips from "../pages/articles/ShoppingTips";
import FaceOff from "../pages/articles/FaceOff";
import ProductTracker from "../pages/articles/ProductTracker";
import FutureTrends from "../pages/articles/FutureTrends";
import TraditionalVsSpreadsheet from "../pages/articles/TraditionalVsSpreadsheet";
import Roundup2026 from "../pages/articles/Roundup2026";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/gtbuy-spreadsheet-ultimate-guide",
    element: <ArticlePage />,
  },
  {
    path: "/gtbuy-spreadsheet-beginners-guide",
    element: <BeginnersGuide />,
  },
  {
    path: "/kakobuy-spreadsheet-review",
    element: <KakobuyReview />,
  },
  {
    path: "/superbuy-spreadsheet-comparison",
    element: <SuperbuyComparison />,
  },
  {
    path: "/best-spreadsheet-shopping-system",
    element: <BestSystems />,
  },
  {
    path: "/is-gtbuy-spreadsheet-safe",
    element: <SafetyGuide />,
  },
  {
    path: "/spreadsheet-shopping-tips",
    element: <ShoppingTips />,
  },
  {
    path: "/gtbuy-vs-kakobuy-vs-superbuy",
    element: <FaceOff />,
  },
  {
    path: "/product-spreadsheet-tracker",
    element: <ProductTracker />,
  },
  {
    path: "/spreadsheet-shopping-future",
    element: <FutureTrends />,
  },
  {
    path: "/spreadsheet-shopping-vs-traditional",
    element: <TraditionalVsSpreadsheet />,
  },
  {
    path: "/best-product-spreadsheet-2026",
    element: <Roundup2026 />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;